import axios from "axios";
import qs from "qs";

import { httpMethods } from "../../../appConstants";
import { isDefined } from "../../../utils";

let instance = null;
let defaultResponse = {};
let defaultTimeout = 30000;

export function setupNetwork() {
  instance = axios.create({
    paramsSerializer: function(params) {
      return qs.stringify(params, { indices: false });
    }
  });
  instance.interceptors.request.use(
    config => {
      config.headers.common = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: " application/json",
        ...config.headers.common
      };
      if (!isDefined(config.timeout)) config.timeout = defaultTimeout;
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    response => {
      return parseBody(response);
    },
    error => {
      if (error.response) {
        return parseError(error.response.data);
      } else {
        return Promise.reject(error);
      }
    }
  );
}

export function sendRequest({
  onBegin,
  onSuccess,
  onFail,
  onFinally,
  method = httpMethods.GET,
  params,
  headers,
  url
} = {}) {
  if (!url) return;
  if (onBegin && onBegin instanceof Function) {
    onBegin();
  }
  return new Promise((resolve, reject) => {
    call({ url: url, params, method, headers })
      .then(result => {
        if (onSuccess && onSuccess instanceof Function) {
          onSuccess(result);
        }
        resolve(result);
      })
      .catch(error => {
        if (onFail && onFail instanceof Function) {
          onFail(error);
        }
        reject(error);
      })
      .then(() => {
        if (onFinally && onFinally instanceof Function) {
          onFinally();
        }
      });
  });
}

function call({ method = httpMethods.GET, params = {}, url, headers = {} }) {
  switch (method) {
    case httpMethods.GET:
      return instance.get(url, { params, headers });
    case httpMethods.POST:
      return instance.post(url, params, { headers });
    case httpMethods.PUT:
      return instance.put(url, params, { headers });
    case httpMethods.PATCH:
      return instance.patch(url, params, { headers });
    case httpMethods.DELETE:
      return instance.delete(url, { data: params }, { headers });
    default:
      return defaultResponse;
  }
}

function parseError(messages) {
  if (messages) {
    return Promise.reject({
      messages: messages instanceof Array ? messages : [messages]
    });
  } else {
    return Promise.reject({
      messages: []
    });
  }
}

function parseBody(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    return parseError(response.data.messages);
  }
}

export let network = instance;


// WEBPACK FOOTER //
// ./src/components/ui-ant/misc/network.js